import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[applyOnlyNumbers]",
})
export class ApplyOnlyNumbersDirective {
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent): void {
    // Allow: backspace, delete, tab, escape, enter, arrows
    if (["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x"].includes(event.key.toLowerCase())) {
      return;
    }
    // Prevent non-numeric
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
